import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import getNewRelicInstance from './getNewRelicInstance';
// This class is used to create consistent error naming before it is passed to New Relic
export var NewRelicError = /*#__PURE__*/function (_Error) {
  function NewRelicError(_ref) {
    var _this2;
    var error = _ref.error,
      location = _ref.location,
      severity = _ref.severity,
      statusCode = _ref.statusCode;
    _classCallCheck(this, NewRelicError);
    var message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      try {
        message = JSON.stringify(error);
      } catch (_unused) {
        message = '"Unable to JSON.stringify() error"';
      }
    }
    var stack = error instanceof Error ? error.stack : undefined;
    var statusCodeMessage = statusCode ? "; statusCode: ".concat(statusCode) : '';
    var detailedMessage = "message: ".concat(message, "; location: ").concat(location, "; severity: ").concat(severity).concat(statusCodeMessage);
    _this2 = _callSuper(this, NewRelicError, [detailedMessage]);
    _this2.stack = stack;
    Object.setPrototypeOf(_this2, NewRelicError.prototype);
    return _this2;
  }
  _inherits(NewRelicError, _Error);
  return _createClass(NewRelicError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// logs error to New Relic dashboard using noticeError API
var captureError = function captureError(errAttributes, customAttributes) {
  var nrInstance = getNewRelicInstance();
  nrInstance.noticeError(new NewRelicError(errAttributes), customAttributes);
};
export default captureError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/observability/dist/esm/NewRelicHelpers/captureError.js
// module id = 2329
// module chunks = 11